import notificationCard from './card/notificationCard';
import profileBreadcrumbs from './breadcrumbs-profile/breadcrumbsProfile';
import groupIdToName from './group-id-to-name/groupIdToName';
import slackUsername from './slack-username/slackUsername';
import defaultNotificationTarget from './default-notification-target/defaultNotificationTarget';
import easyNotificationForm from './easy-notification-form/easyNotificationForm';
import notificationTarget from './notification-components/notificationTarget';
import notificationTrigger from './notification-components/notificationTrigger';
import enableField from './notification-components/enableField';


const toLoad = [
  profileBreadcrumbs,
  groupIdToName,
  slackUsername,
  defaultNotificationTarget,
  easyNotificationForm,
  notificationCard,
  notificationTarget,
  notificationTrigger,
  enableField
];


export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
